import { NgModule } from '@angular/core';
import { AdminEditExerciseSlotPage } from 'pages/admin-edit-exercise-slot/admin-edit-exercise-slot';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [AdminEditExerciseSlotPage],
    imports: [PagesModule, ComponentsModule],
    exports: [AdminEditExerciseSlotPage]
})
export class AdminEditExerciseSlotPageModule {}
